import { withSentryReactRouterV7Routing } from "@sentry/react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";

import { AppLayout } from "@/app/AppLayout";
import { Unauthenticated } from "@/app/pages/Unauthenticated";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { estimateTrackerRoutes } from "@/features/estimate-tracking/EstimateTrackerRoutes";
import { EstimatesList } from "@/features/estimates/EstimatesList";
import { jobTrackerRoutes } from "@/features/job-tracking/JobTrackerRoutes";
import { NCRLog } from "@/features/ncrs/NCRLog";
import { OrderLog } from "@/features/orders/OrderLog";
import { VendorAssessmentLog } from "@/features/vendor-assessments/VendorAssessmentLog";
import { NotFound } from "./pages/NotFound";

// See: https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/#usage-with-routes--component
const SentryRoutes = withSentryReactRouterV7Routing(Routes);

export const AppRouter: React.FC = () => (
  <BrowserRouter>
    <SentryRoutes>
      <Route element={<AppLayout />}>
        <Route element={<ProtectedRoute />}>
          <Route index element={<Navigate to={"/orders"} />} />
          <Route path="estimates" element={<EstimatesList />} />
          <Route path="orders" element={<OrderLog />} />
          <Route path="ncrs" element={<NCRLog />} />
          {jobTrackerRoutes}
          {estimateTrackerRoutes}
          <Route path="qms/vendor-assessments" element={<VendorAssessmentLog />} />
        </Route>
        <Route path="unauthenticated" element={<Unauthenticated />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </SentryRoutes>
  </BrowserRouter>
);
